// extracted by mini-css-extract-plugin
module.exports = {"container":"NavigationToHousingStock_container__249SS","btnWrap":"NavigationToHousingStock_btnWrap__3vZjz","icon":"NavigationToHousingStock_icon__2Z9Ho"};